import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import saloon from '../images/saloon.jpg';
import certificates from '../images/certificates.jpg';
import products from '../images/products.jpg';
import tools from '../images/tools.jpg';


function ImageCarousel(props) {  
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  
  return (
    <Carousel
    swipeable={true}
    draggable={false}
    showDots={true}
    responsive={responsive}
    ssr={false}
    infinite={true}
    autoPlay={false}
    keyBoardControl={true}
    customTransition="transform 300ms ease-in-out"
    transitionDuration={500}
    containerClass="carousel-container"
    removeArrowOnDeviceType={["tablet", "mobile"]}
    deviceType={props?.deviceType}
    dotListClass="custom-dot-list-style"
    itemClass="carousel-item-padding-40-px"
  >
    <img
      src={saloon}
      alt="Интериор на Alexiev's Barbershop"
      style={{ width: `${409 * 1.5}px`, height: `${272 * 1.25}px`, objectFit: 'cover' }}
    />
    <img
      src={certificates}
      alt="Сертификати на Alexiev's Barbershop"
      style={{ width: `${409 * 1.5}px`, height: `${272 * 1.25}px`, objectFit: 'cover' }}
    />
    <img
      src={tools}
      alt="Инструменти на Alexiev's Barbershop"
      style={{ width: `${409 * 1.5}px`, height: `${272 * 1.25}px`, objectFit: 'cover' }}
    />
    <img
      src={products}
      alt="Професионални продукти в Alexiev's Barbershop"
      style={{ width: `${409 * 1.5}px`, height: `${272 * 1.25}px`, objectFit: 'cover' }}
    />
  </Carousel>
  )
}

export default ImageCarousel